// @ts-strict-ignore
import type { Module } from 'vuex'

import type { CrudState } from '../../models'

import { CreateAction } from '../../store/crud/actions/create.action'
import { DeleteAction } from '../../store/crud/actions/delete.action'

import { FetchDataAction } from '../../store/crud/actions/fetch-data.action'
import { ListAction } from '../../store/crud/actions/list.action'
import { ReadAction } from '../../store/crud/actions/read.action'
import { TagAction } from '../../store/crud/actions/tag.action'
import { UpdateAction } from '../../store/crud/actions/update.action'
import { CRUD_CONSTS } from '../../store/crud/crud.consts'
import { StateGetter } from '../../store/crud/getters/state.getter'
import { SetStateMutation } from '../../store/crud/mutations/set-state.mutation'
import { ResetAction } from '../common/actions/reset.action'
import { ResetMutation } from '../common/mutations/reset.mutation'

export const CRUD_MODULE: Module<CrudState, any> = {
  namespaced: true,

  initialState: (): CrudState => ({
    data: [],
    pagination: {
      page: 1,
      itemsPerPage: 0,
      totalItems: 0,
    },
    sort: {},
  }),
  state: (): CrudState => CRUD_MODULE.initialState(),

  getters: {
    [CRUD_CONSTS.getters.state]: StateGetter.execute,
  },

  actions: {
    [CRUD_CONSTS.actions.list]: ListAction.execute,
    [CRUD_CONSTS.actions.create]: CreateAction.execute,
    [CRUD_CONSTS.actions.read]: ReadAction.execute,
    [CRUD_CONSTS.actions.update]: UpdateAction.execute,
    [CRUD_CONSTS.actions.delete]: DeleteAction.execute,

    [CRUD_CONSTS.actions.fetchData]: FetchDataAction.execute,
    [CRUD_CONSTS.actions.tag]: TagAction.execute,
    [CRUD_CONSTS.actions.reset]: context =>
      ResetAction.execute(context, CRUD_MODULE.initialState()),
  },

  mutations: {
    [CRUD_CONSTS.mutations.setState]: SetStateMutation.execute,
    [CRUD_CONSTS.mutations.reset]: ResetMutation.execute,
  },
}
